import { NormalCode } from './../../shared/utils/normalCode';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
// 引入公共函数
import * as publicMethods from './../../shared/utils/publicMethods';
import { map } from 'rxjs/operators';
import { RespEntityUtil } from './entity/respEntityUtil';
import { RespCodeEntityUtil } from './entity/respCodeEntityUtil';
import { NzMessageService } from "ng-zorro-antd";
import { CacheService } from '@delon/cache';
import { PublicParams } from '@shared/utils/publicParams';
import { UserDetailResp } from '@shared/utils/userDetailResp';

/**
 * http请求公用函数
 * @author miqiang
 * @date 2019-10-17
 */
@Injectable({
    providedIn: 'root',
})
export class PublicHttpService {
    protected http: HttpClient;

    protected message: NzMessageService;

    protected cacheService: CacheService;

    protected userDetailResp: UserDetailResp;

    constructor(protected injector: Injector) {
        this.http = injector.get(HttpClient);
        this.message = injector.get(NzMessageService);
        this.cacheService = injector.get(CacheService);
    }

    hasPermission(url: string) {
        this.userDetailResp = JSON.parse(sessionStorage.getItem(PublicParams.cacheUserName));
        if (this.userDetailResp.role.includes(PublicParams.admin_role)) {
            return true;
        } else if (this.userDetailResp.permissions && this.userDetailResp.permissions.length > 0) {
            if (url.startsWith("/")) {
                url = url.substring(1);
            }
            PublicParams.routeUrls.forEach((routeUrl: string) => {
                if (url.startsWith(routeUrl)) {
                    url = url.substring(routeUrl.length);
                }
            });
            if (this.userDetailResp.permissions.includes(url)) {
                return true;
            }
        }
        return false;

        //     this.cacheService.get(PublicParams.cacheUserName).subscribe((userDetailResp: UserDetailResp) => {
        //         // if (userDetailResp.role.includes(PublicParams.admin_role)) {
        //         //     return true;
        //         // } else if (userDetailResp.permissions && userDetailResp.permissions.length > 0) {
        //         //     if (userDetailResp.permissions.includes(url)) {
        //         //         return true;
        //         //     }
        //         // }
        //         return false;
        //     });

    }

    /**
     * 修改数据的启用/禁用状态
     * @param url       要调取的url
     * @param openid    主键id
     * @param enable    启用/禁用
     * @param data      列表数据。用于修改页面列表中的启用/禁用值
     * @param cache     缓存数据。用于修改缓存数据中的启用/禁用值
     * @param switchLoading 显示加载中效果，为空时没有效果
     * @returns	修改后的启用/禁用值
     */
    updEnable(url: string, openid: string, enable: string, data: Array<any>, cache?: any, switchLoading?: boolean) {
        const par = publicMethods.generateFormData({ openid, enable: enable === '启用' ? 0 : 1 });
        this.upd(url, par).subscribe((response: any) => {
            data.forEach((element: any) => {
                if (element.openid === openid) {
                    if (response.err_code === NormalCode.NORMAL_CODE) {
                        element.enable = enable === '启用' ? '禁用' : '启用';
                        if (null != cache) {
                            cache.enable = enable === '启用' ? '禁用' : '启用';
                        }
                    } else {
                        element.enable = enable === '启用' ? '启用' : '禁用';
                        if (null != cache) {
                            cache.enable = enable === '启用' ? '启用' : '禁用';
                        }
                    }
                }
            });
        });
    }

    /**
     * 删除数据（多行删除）
     * @param url 		要调取的url
     * @param openids 	主键id，多个id用逗号分隔
     * @param loading 显示加载中效果，为空时没有效果
     */
    delById(url: string, openids: string, loading?: boolean): Observable<any> {
        const par = publicMethods.generateFormData({ openids });
        return this.upd(url, par);
    }

    /**
     * 删除数据(单行删除)
     * @param url       要调取的url
     * @param openid    主键id
     * @param loading   显示加载中效果，为空时没有效果
     */
    delByOpenid(url: string, openid: string, loading?: boolean): Observable<any> {
        const par = publicMethods.generateFormData({ openid });
        return this.upd(url, par);
    }

    /**
     * 修改数据
     * @param url 		要调取的url
     * @param params 	请求参数信息(json)
     * @param loading 显示加载中效果，为空时没有效果
     * @returns 修改结果
     */
    public upd(url: string, params: any, loading?: boolean): Observable<any> {
        if (null != loading) {
            loading = true;
        }
        return this.http.post(url, params).pipe(
            map((response: any) => {
                if (null != loading) {
                    loading = false;
                }
                if (response.err_code === NormalCode.NORMAL_CODE) {
                    this.message.create('success', response.err_msg);
                } else {
                    this.message.create('error', response.err_msg);
                }
                return response;
            }),
        )
    }

    /**
     * 更新数据
     * @param url 		要调取的url
     * @param data 		页面中的列表数据，用于刷新页面中的列表
     * @param cacheData 修改后的缓存数据，用于修改页面中的列表（http请求需要的参数）
     * @returns	更新后的页面列表数据
     */
    updateData(url: string, data: Array<any>, cacheData: any): Observable<any> {
        const para = publicMethods.generateFormData(cacheData);
        return this.http.post(url, para).pipe(
            map((response: any) => {
                if (response.err_code === NormalCode.NORMAL_CODE) {
                    this.message.create('success', response.err_msg);
                    const openid = cacheData.openid;
                    // 重新定义数组进行返回
                    const arr = [];
                    // tslint:disable-next-line: no-shadowed-variable
                    data.forEach(element => {
                        if (element.openid === openid) {
                            element = publicMethods.getNewData(element, cacheData);
                        }
                        arr.push(element);
                    });
                    response.arr = arr;
                } else {
                    this.message.create('error', response.err_msg);
                }
                return response;
            }),
        );
    }

    /**
     * 查询下拉框数据
     * @param url       要调用的url
     * @param params    请求参数，可以为空
     * @returns 构造完成后的下拉框数据集合
     */
    getSelectData(url: string, params: any | null): Observable<Array<RespEntityUtil>> {
        return this.http.post(url, params).pipe(
            map((response: any) => {
                const arr = [];
                if (response.err_msg) {
                    this.message.create('error', response.err_msg);
                } else {
                    // tslint:disable-next-line: no-shadowed-variable
                    response.forEach((element: any) => {
                        const name = element.name ? element.name : element.zdxsmc;
                        const data = new RespEntityUtil(element.openid, name);
                        arr.push(data);
                    });
                }
                return arr;
            }),
        );
    }


    /**
     * 查询下拉框数据
     * @param url       要调用的url
     * @param params    请求参数，可以为空
     * @returns 构造完成后的下拉框数据集合
     */
    getSelectCodeData(url: string, params: any | null): Observable<Array<RespCodeEntityUtil>> {
        return this.http.post(url, params).pipe(
            map((response: any) => {
                const arr = [];
                if (response.err_msg) {
                    this.message.create('error', response.err_msg);
                } else {
                    // tslint:disable-next-line: no-shadowed-variable
                    response.forEach((element: any) => {
                        const name = element.name ? element.name : element.zdxsmc;
                        const data = new RespCodeEntityUtil(element.openid, element.code, name);
                        arr.push(data);
                    });
                }
                return arr;
            }),
        );
    }
}
